<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description"
       [innerHTML]="getLangValue(stepData?.description)"></div>
  <ng-container *ngIf="isMultiline; else singleInput">
    <textarea #textareaEl [(ngModel)]="feedback" class="survey-text-input"
      [placeholder]="getLangValue(stepData?.options[0]?.text)"></textarea>
  </ng-container>
  <ng-template #singleInput>
    <input #inputEl [type]="inputType" [(ngModel)]="feedback" class="survey-text-input"
      [placeholder]="getLangValue(stepData?.options[0]?.text)"/>
  </ng-template>
</div>
